var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#251163"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4438_46089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17.569C7 17.9157 7.078 18.258 7.234 18.596L8.625 17.205V9.834L7.234 8.43C7.078 8.75067 7 9.08867 7 9.444V17.569ZM8.365 7.26L9.73 8.625H17.283L18.648 7.26C18.284 7.08667 17.9243 7 17.569 7H9.444C9.08 7 8.72033 7.08667 8.365 7.26ZM8.378 19.753C8.72467 19.9177 9.08 20 9.444 20H17.569C17.933 20 18.284 19.9177 18.622 19.753L17.257 18.375H9.743L8.378 19.753ZM10.25 16.75H16.75V15.125H10.25V16.75ZM10.25 14.319H16.75V12.694H10.25V14.319ZM10.25 11.875H16.75V10.25H10.25V11.875ZM18.375 17.205L19.766 18.596C19.922 18.258 20 17.9157 20 17.569V9.444C20 9.08867 19.9263 8.75067 19.779 8.43L18.375 9.834V17.205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4438_46089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrate);
export default __webpack_public_path__ + "static/media/crate.5ce1382fdfaf342a9f2896ba073aac66.svg";
export { ForwardRef as ReactComponent };